import React from "react";
import type { Key } from "react-aria-components";
import { t } from "ttag";

import { GuidesBlock } from "@reactivated";

import { Carousel } from "../Carousel";
import { Clickable } from "../Clickables";
import { Dots } from "../Clickables/Dots";
import { Pill, PillGroup } from "../Clickables/Pills";
import { ThemedModule } from "../ThemedModule";
import { TileImage } from "../TileImage";

import styles from "./GuidesCarousel.module.scss";

const UNFILTERED = "__all__";

export const GuidesCarousel = ({ value }: { value: GuidesBlock }) => {
    const [selectedFilterValue, setSelectedFilter] =
        React.useState<Key>(UNFILTERED);
    const filteredArticles = value.articles?.filter((article) => {
        if (selectedFilterValue === UNFILTERED) return true;
        return article.tags.some((tag) => tag.value === selectedFilterValue);
    });
    return (
        <ThemedModule theme={value.module_theme}>
            {value.filters && value.filters.length > 0 && (
                <PillGroup
                    className={styles.filters}
                    aria-label={t`Filter guides`}
                    selectionMode="single"
                    disallowEmptySelection
                    defaultSelectedKeys={[UNFILTERED]}
                    onSelectionChange={(selection) => {
                        setSelectedFilter(
                            selection.values().next().value ?? UNFILTERED,
                        );
                    }}
                >
                    <Pill id={UNFILTERED}>{t`All Guides`}</Pill>
                    {value.filters.map(({ value: filter, id }) => (
                        <Pill id={filter.value} key={id}>
                            {filter.display_name}
                        </Pill>
                    ))}
                </PillGroup>
            )}
            <Carousel
                label={t`Check out these guides`}
                advanceBy="page"
                loop={false}
                controls={false}
                containerProps={{ className: styles.carousel }}
                scrollContainerProps={{ className: styles.scroller }}
                dots={
                    filteredArticles && (
                        <Dots slideCount={filteredArticles.length} />
                    )
                }
            >
                {filteredArticles?.map((article) => (
                    <Clickable
                        className={styles.guideTile}
                        key={article.id}
                        href={article.url}
                        aria-label={t`View guide: ${article.title}`}
                    >
                        <TileImage value={article} />
                    </Clickable>
                ))}
            </Carousel>
        </ThemedModule>
    );
};
